/**
 * App Entry File
 * Vuely: A Powerfull Material Design Admin Template
 * Copyright 2018. All Rights Reserved
 * Created By: The Iron Network, LLC
 * Made with Love
 */
import 'babel-polyfill'
import Vue from 'vue'
import VueAxios from 'vue-axios'
import axios from 'axios'
import Vuetify from 'vuetify'
import * as VueGoogleMaps from 'vue2-google-maps'
import lodash from 'lodash'
import { Vue2Dragula } from 'vue2-dragula'
import VueQuillEditor from 'vue-quill-editor'
import wysiwyg from 'vue-wysiwyg'
import VueBreadcrumbs from 'vue2-breadcrumbs'
// import VueResource from 'vue-resource'
import Notifications from 'vue-notification'
import velocity from 'velocity-animate'
import AmCharts from 'amcharts3'
import AmSerial from 'amcharts3/amcharts/serial'
import AmAngularGauge from 'amcharts3/amcharts/gauge'
import Nprogress from 'nprogress'
import VueI18n from 'vue-i18n'
import VueTour from 'vue-tour'
import fullscreen from 'vue-fullscreen'
import InstantSearch from 'vue-instantsearch'
import VueVideoPlayer from 'vue-video-player'
import Croppa from 'vue-croppa'
import esValidate from 'vee-validate/dist/locale/es'
import VeeValidate, { Validator } from 'vee-validate'
import moment from 'moment';
import '@fortawesome/fontawesome-free/css/all.css'


// global components
import GlobalComponents from './globalComponents'

// app.vue
import App from './App'

// router
import router from './router'

// themes
import primaryTheme from './themes/primaryTheme'

// store
import { store } from './store/store'

// include script file
import './lib/VuelyScript'

// include all css files
import './lib/VuelyCss'

// messages
import messages from './lang'

window.lodash = lodash
window.toProperty = (obj, array) => {
    while (array.length) {
        obj = obj[array.shift()]
    }
    return obj
}

// navigation guards before each
router.beforeEach( (to, from, next) => {
	Nprogress.start()
	if (to.matched.some(record => record.meta.requiresAuth)) {
		if (localStorage.getItem('user') === null) {
			next({
				path: '/session/login',
				query: { redirect: to.fullPath }
			})
		} else if (to.meta.requiresPermission) {
		    if (store.getters.getPermission(to.meta.requiresPermission)) {
                next()
            } else {
                setTimeout(() => {
                    store.commit('snackbar', {color: 'error', message: `No tiene permisos para ingresar al módulo ${to.meta.pageTitle.title}.`})
                }, 200)
                next({
                    name: 'Dashboard'
                })
            }
		} else {
            next()
        }
	} else {
		next() // make sure to always call next()!
	}
})

// navigation guard after each
router.afterEach(async (to, from) => {
    if (localStorage.getItem('user') && !store.getters.activesMenus) {
        if (store.getters.getPermission('mipres.show')) {
            router.push({name: 'Mipres'})
        } else {
            router.push({name: 'Dashboard'})
        }
    }
	setTimeout(() => {
		const contentWrapper = document.querySelector('.v-content__wrap')
		if(contentWrapper !== null){
			contentWrapper.scrollTop = 0
		}
		const boxedLayout = document.querySelector('.app-boxed-layout .app-content')
		if(boxedLayout !==  null){
			boxedLayout.scrollTop = 0
		}
		const miniLayout = document.querySelector('.app-mini-layout .app-content')
		if(miniLayout !== null){
			miniLayout.scrollTop = 0
		}
        Nprogress.done()
	}, 200)
})



// plugins
import es from 'vuetify/es5/locale/es'
Vue.use(Vuetify, {
	theme: store.getters.selectedTheme.theme,
    iconfont: ['fa', 'mdi'],
    lang: {
	    locales: { es },
        current: 'es'
    }
})
Vue.use(InstantSearch)
Vue.use(VueI18n)
Vue.use(AmCharts)
Vue.use(AmSerial)
Vue.use(VueTour)
Vue.use(AmAngularGauge)
Vue.use(Vue2Dragula)
Vue.use(VueQuillEditor)
// Vue.use(VueResource)
Vue.use(wysiwyg, {})
Vue.use(VueBreadcrumbs)
Vue.use(Notifications, { velocity })
Vue.use(fullscreen)
Vue.use(GlobalComponents)
Vue.use(VueVideoPlayer)
Vue.use(Croppa)
Validator.localize('es', esValidate)
Vue.use(VeeValidate, {locale: 'es'})
moment.locale('es')
Vue.prototype.moment = moment
Vue.use(VueGoogleMaps, {
	load: {
		key: 'AIzaSyBtdO5k6CRntAMJCF-H5uZjTCoSGX95cdk' // Add your here your google map api key
	}
})
axios.defaults.baseURL = window.location.origin + ':8000/api/v1'
// axios.defaults.baseURL = 'http://testing.mipres. test:9000/api/v1'
// axios.defaults.baseURL = 'http://samediq.mipres.test:8000/api/v1'
// axios.defaults.baseURL = 'https://puertabierta.easymipres.com:8000/api/v1'
// axios.defaults.baseURL = 'https://simalink.easymipres.com:8000/api/v1'
// axios.defaults.baseURL = 'http://horo.mipres.test:8000/api/v1'
Vue.use(VueAxios, axios)
store.commit('assignTokenAxios')
axios.interceptors.response.use(undefined, (error) => {
    const originalRequest = error.config
    if (error.response.status === 401) {
		return new Promise(resolve => {
            store.dispatch('refreshToken').then(result =>{
                if (result){
                    originalRequest.headers['Authorization'] = result
                    resolve(axios(originalRequest))
                } else {
                    store.commit('loginUserReauth')
                }
            })
        })
    }
    if (error.response.status === 412) {
        store.commit('loginUserReauth')
    }
    return Promise.reject(error)
})

// Create VueI18n instance with options
const i18n = new VueI18n({
	locale: store.getters.selectedLocale.locale, // set locale
	messages, // set locale messages
})

Vue.mixin({
    computed: {
        generarSoporte () {
            return store.getters.getPermissionModule('proceso') && store.getters.getPermissionModule('proceso').generarSoporte
        }
    },
    methods: {
        async getSettings () {
            return await new Promise((resolve, reject) => {
                axios.get(`settings`)
                    .then(response => resolve(response.data))
                    .catch(e => {
                        store.commit('snackbar', {color: 'error', message: `al traer las configuraciones de proceso`, error: e})
                        reject(e)
                    })
            })
        },
        valorDecimal: (valor) => {
            return new Intl.NumberFormat('es-CO', {style: 'decimal', useGrouping: false}).format(valor)
        },
        currency: (valor) => {
            return new Intl.NumberFormat('es-CO', {style: 'currency', currency: 'COP'}).format(valor)
        },
        async descargarArchivo(archivo){
            return new Promise(resolve => {
                this.axios( {
                    url: archivo.url, //your url
                    method: 'GET',
                    responseType: 'blob', // important
                }).then( async response => {
                    const fileURL = window.URL.createObjectURL(new Blob(
                        [response.data],
                        {type: archivo.type || 'application/pdf'}))
                    let win = await window.open(fileURL,archivo.target || '_blank')
                    resolve(true)
                    win.focus()
                }).catch(error => {
                    store.commit('snackbar', {color: 'error', message: 'al generar el archivo', error: error})
                    resolve(false)
                })
            })
        }
    }
})

/* eslint-disable no-new */
new Vue({
	store,
	i18n,
	router,
	render: h => h(App),
	components: { App }
}).$mount('#app')
